import { render, staticRenderFns } from "./salarydealfrm.vue?vue&type=template&id=07f03c12"
import script from "./salarydealfrm.vue?vue&type=script&lang=js"
export * from "./salarydealfrm.vue?vue&type=script&lang=js"
import style0 from "./salarydealfrm.vue?vue&type=style&index=0&id=07f03c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports